<template>
  <div id="app">
    <div v-if="$root.ready && overflow" class="ready-overflow" @click="openWebsite()">
      <button class="btn btn-outline-primary text-uppercase" @click="openWebsite()">Buka Undangan</button>
    </div>
    <AGWAudio ref="audio" :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :images="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <AGWPawiwahan id="pawiwahan" class="bg-blue-light py-5" />
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes" />

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class=""/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.188617116777!2d115.2371035146146!3d-8.673605490693369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd241e9c814a4b1%3A0xaf9a89d14651b8b7!2sCasa%20Bunga!5e0!3m2!1sen!2sid!4v1599144960325!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//Casa+Bunga,+Jl.+Raya+Puputan+No.178,+Renon,+Denpasar+Selatan,+Denpasar+City,+Bali+80239/@-8.6736108,115.2392922,18z/data=!4m6!4m5!1m0!1m2!1m1!1s0x2dd241e9c814a4b1:0xaf9a89d14651b8b7!3e0"
        :location="location"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/SKP_5860_aiu2sBhdi0.jpg'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/SKF_9730_tixzlTwFSh.jpg'

import Audio from "@/assets/audio/a-himitsu-in-love.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryTwo";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Wedding',
      backgrounds: [ImageHero1, ImageHero2],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      location: "Casa Bunga, Jl. Raya Puputan Renon no. 178. Denpasar - Bali",
      // date: "2020-04-05",
      time: {
        start: this.$moment("2020-10-20 18:00"),
        end: "Selesai"
      },
      wedding: {
        man: {
          name: 'Riston Ledoh',
          surname: 'Ryston',
          parents: 'Bpk. Thobias Ledoh (Alm) & Ibu Elisabet Ledoh',
          description: 'Putra ',
          address: 'Jl. Letda Made Putra no. 40, Denpasar - Bali',
        },
        woman: {
          name: 'Novita Natalia Surah',
          surname: 'Natalia',
          parents: 'Bpk. Oscar Surah (Alm) & Ibu Ni Nyoman Rai Ardini',
          address: 'Jl. Letda Made Putra no. 14, Denpasar - Bali',
          description: 'Putri ',
        },
      },
      mepandes: [],
      gallery: [
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/SKF_9675_hl8Mdhxnot.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9380_8wvxOX9AS.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/SKF_9730_tixzlTwFSh.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9354_FlIqiqYFYb.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9386_xUNA1vqfr.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/SKF_9683_WnLbl0xlzEnQ.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9378_lOmZa1mDngeA.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9375_p9AYHIDYzFNc.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9376_ppp0aIALDl_A.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9391_tYKX5_vgug6.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/DSCF9384_rJbwh8yRZqHC.jpg',
        'https://ik.imagekit.io/aryraditya/ceremonyku/ryston-natalia/SKF_9756_q_tTvLd6mjh.jpg',
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.sw.refreshing) return;
      this.sw.refreshing = true;
      window.location.reload();
    });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  }
};
</script>

<style lang="scss">
.ready-overflow {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  z-index: 1001;
  align-items: center;
  justify-content: center;
  transform: translateY(170px);
  text-transform: uppercase;

  button {
    letter-spacing: 1.2px;
  }
}
</style>
